import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-add-dialog-agrement',
    templateUrl: './add-dialog-agrement.component.html',
    styleUrls: ['./add-dialog-agrement.component.css'],
})
export class AddDialogAgrementComponent implements OnInit {
    codefils: any;
    form = new FormGroup({
        licenseNm: new FormControl(null, [Validators.required]),
        licenseCd: new FormControl(null, [Validators.required]),
        licenseRegNo: new FormControl(null, [Validators.required]),
        issuedInst: new FormControl(null, [Validators.required]),
        issuedYmd: new FormControl(null, [Validators.required]),
        expirationYmd: new FormControl(null, [Validators.required]),
    });

    constructor(
        private dialog: MatDialogRef<AddDialogAgrementComponent, { data: any }>
    ) {
    }

    get currentDate() {
        return new Date();
    }

    get currentDateYestaday() {
        let aDate = new Date();
        aDate.setDate(aDate.getDate() - 1);
        return aDate;
    }

    getFormControl(key: string): FormControl {
        return this.form.controls[key] as FormControl;
    }

    ngOnInit(): void {
    }

    onSuccessAdd() {
        if (this.form.valid) {
            const data = this.form.getRawValue();

            this.dialog.close({
                data: data,
            });
        }
    }

    getobject(data: any) {
        this.codefils = data.cd;
    }
}
